import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';
import { TextStyle } from '@superops/ui-design-system';
import {
  CurrencyText,
  getTranslatedText,
  Row as RowLayout
} from '@nile/components';
import envConfig from '@nile/home/src/Config/env';
import { invoiceDefaultColumnCells } from '@nile/client_management/src/Pages/Invoice/Utils/cells';

const getSubTotal = (items) => {
  let sTotal = 0;
  (items || []).forEach((el) => {
    sTotal += Number(el.amount);
  });
  return sTotal;
};

const Row = styled.div`
  line-height: 35px;
  font-weight: 500;
  width: ${(props) => props.width};
`;

export function InvoiceTableView({
  data: items,
  isSiteWiseSplitEnabled = false,
  siteName,
  clientName,
  renderTable: renderTableView,
  label,
  isGroupByCategoryEnabled,
  hasTotalHours,
  totalHours
}) {
  const intl = useIntl();
  const renderTable = renderTableView({
    noBulkSelect: true,
    fullHeight: true,
    dark: true,
    rowCount: 10000,
    alignStart: true,
    defaultColumnCells: invoiceDefaultColumnCells,
    pagination: false,
    pages: 0,
    emptyState: {
      nodataImage: `${envConfig.imageRoot}svg/not-found.svg`,
      heading: getTranslatedText(intl, 'invoice.list.noItems'),
      description: ''
    },
    context: { records: [] },
    data: items
  });

  if (!isSiteWiseSplitEnabled && !isGroupByCategoryEnabled) {
    return renderTable;
  }

  const header = (
    <div className="mb-10">
      <div className="font-weight-600 f-14">
        {label ?? `${clientName} - ${siteName}`}
      </div>
    </div>
  );

  const renderSubTotalRow = (
    <Row className="flex center" width="15%">
      <div className="grow-1 fb-25 self-start mr10">
        <div className="font-weight-600">
          <FormattedMessage id="invoice.details.list.subTotal" />
          <TextStyle className="ml-5">:</TextStyle>
        </div>
      </div>
      <div className="flex jend bold pr-15 grow-1 fb-25 self-start mr10 ">
        <CurrencyText value={getSubTotal(items)} />
      </div>
    </Row>
  );

  const renderTotalHoursRow = hasTotalHours && (
    <Row className="flex center">
      <div className="grow-1 self-start mr10">
        <div className="font-weight-600">
          <FormattedMessage id="invoice.usageReport.totalHours" />
          <TextStyle className="ml-5">:</TextStyle>
        </div>
      </div>
      <div className="bold grow-1">{totalHours}</div>
    </Row>
  );

  return (
    <div>
      {header}
      {renderTable}
      <RowLayout className="flex center jend" gap={100}>
        {renderTotalHoursRow}
        {renderSubTotalRow}
      </RowLayout>
    </div>
  );
}
